<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: AppTextMarkdown
 * Renders Strapi rich text with AppText typography classes: CKEditor HTML is
 * post-processed (h2 slug ids for TOC, image URL/lazy attrs), legacy markdown
 * strings still go through marked. Inline `<a>` links inherit AppTextLink style.
 */
// types
import type { AppTextMarkdownProps } from '../types/interfaces'
// hooks
import { useAppText } from '../../AppText/composables/use-app-text.hook'
import { useAppTextMarkdown } from '../composables/use-app-text-markdown.hook'

defineOptions({
  name: 'AppTextMarkdown',
})

const props = withDefaults(defineProps<AppTextMarkdownProps>(), {
  name: 'body2',
  align: 'inherit',
  textDecoration: 'none',
  block: true,
  truncate: false,
})

const { classList } = useAppText({ props })
const { refHtml } = useAppTextMarkdown({ props })
</script>

<template>
  <div
    :class="['app-text-markdown', ...classList]"
    v-html="refHtml"
  />
</template>

<style lang="scss" scoped src="../styles/_app-text-markdown.scss" />
